import React from "react";
import Card from "../../components/Card";
import Table from "../../components/Table";
import EditClientModal from "./Components/EditClientModal";
import {
  documentStatusOptions,
  approveStatusOptions,
  entityCategoryOptions,
  entityListColumns,
  DocListInline,
  useEntityList,
} from "./TableData";
import SearchBar from "../../components/SearchBar";
import dataNotFound from "../../assets/images/emptyPageImage.png";
import DropDown from "../../components/DropDown";
import "./index.scss";

const ClientList = () => {
  const {
    isEditModalOpen,
    selectedClient,
    isLoading,
    handleEdit,
    handleSaveClient,
    handleApproveClient,
    handleDeficiencyClient,
    handleCloseModal,
    handleDelete,
    currentEntities,
    pageSize,
    handleLoadMore,
    handleLoadLess,
    pagination,
    searchQuery,
    setSearchQuery,
    entityCategory,
    setEntityCategory,
    documentStatus,
    setDocumentStatus,
    approveStatus,
    setApproveStatus,
  } = useEntityList();

  return (
    <div className="client-list-page">
      <div className="page-header">
        <h1 className="page-title">All Clients/Vendor</h1>
      </div>

      <div className="filter-container-box">
        <SearchBar
          value={searchQuery}
          onChange={setSearchQuery}
          placeholder="Search by entity name, email..."
        />
        <DropDown
          name="entityCategory"
          value={entityCategory}
          onChange={(e) => setEntityCategory(e.target.value)}
          options={entityCategoryOptions}
        />
        <DropDown
          name="documentStatus"
          value={documentStatus}
          onChange={(e) => setDocumentStatus(e.target.value)}
          options={documentStatusOptions}
        />
        <DropDown
          name="approveStatus"
          value={approveStatus}
          onChange={(e) => setApproveStatus(e.target.value)}
          options={approveStatusOptions}
        />
        {/* <div className="clear-filter-container">
          <button onClick={handleClearFilter} className="clear-filter-text">
            Clear filter
          </button>
        </div> */}
      </div>

      <Card>
        {isLoading ? (
          <div className="loading-state">
            <p>Loading entities...</p>
          </div>
        ) : currentEntities.length === 0 ? (
          <div className="empty-state">
            <img
              src={dataNotFound}
              className="data-not-found-img"
              alt="data not found"
            />

            {/* <p>No entities found.</p> */}
          </div>
        ) : (
          <div className="entity-table-wrapper">
            <Table
              columns={entityListColumns}
              data={currentEntities}
              onEdit={handleEdit}
              onDelete={handleDelete}
              showPagination={false}
              expandedRow={(row) => (
                <div className="doc-expand-row">
                  <span className="doc-expand-label">Required Documents:</span>
                  <DocListInline
                    documents={row.documents || []}
                    entityData={row.entity || {}}
                  />
                </div>
              )}
            />
            {/* pageSize grows: 10 → 20 → 30 on each "More" click */}
            <div className="simple-pagination">
              <button
                className="simple-pagination__btn"
                onClick={handleLoadLess}
                disabled={pageSize <= 10}
              >
                ‹ Less
              </button>
              <span className="simple-pagination__info">
                Showing {pageSize}
                {pagination.totalItems > 0 &&
                  ` · ${pagination.totalItems} total`}
              </span>
              <button
                className="simple-pagination__btn"
                onClick={handleLoadMore}
                disabled={currentEntities.length < pageSize}
              >
                More ›
              </button>
            </div>
          </div>
        )}
      </Card>

      <EditClientModal
        isOpen={isEditModalOpen}
        onClose={handleCloseModal}
        clientData={selectedClient}
        onSave={handleSaveClient}
        onApprove={handleApproveClient}
        onDeficiency={handleDeficiencyClient}
      />
    </div>
  );
};

export default ClientList;
